import React from "react";
import styled from "@emotion/styled";
import {Spinner} from "views/components/spinner";
import {theme} from "data/constants/theme";

const PreloaderWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const PreloaderContent = styled.div`
	display: inline-block;
	position: relative;
	width: 80px;
	height: 24px;

	@keyframes lds-ellipsis1 {
		0% {
			transform: scale(0);
		}
		100% {
			transform: scale(1);
		}
	}

	@keyframes lds-ellipsis3 {
		0% {
			transform: scale(1);
		}
		100% {
			transform: scale(0);
		}
	}

	@keyframes lds-ellipsis2 {
		0% {
			transform: translate(0, 0);
		}
		100% {
			transform: translate(24px, 0);
		}
	}

	div {
		position: absolute;
		top: 5px;
		width: 13px;
		height: 13px;
		border-radius: 50%;
		background: currentColor;
		animation-timing-function: cubic-bezier(0, 1, 1, 0);
		background: #000;

		&:nth-of-type(1) {
			left: 8px;
			animation: lds-ellipsis1 0.6s infinite;
		}

		&:nth-of-type(2) {
			left: 8px;
			animation: lds-ellipsis2 0.6s infinite;
		}

		&:nth-of-type(3) {
			left: 32px;
			animation: lds-ellipsis2 0.6s infinite;
		}

		&:nth-of-type(4) {
			left: 56px;
			animation: lds-ellipsis3 0.6s infinite;
		}
	}
`;

const SPreloader = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 1000;
	background: #ffffff;

	.loader {
		width: 120px;
		height: 120px;
		transform: rotate(-90deg);
		stroke-linecap: round;
		stroke-width: 4;
		fill: none;
	}

	.loader .internal-circle,
	.loader .external-circle {
		stroke-dashoffset: 0;
		transform-origin: center;
	}

	.loader .internal-circle {
		stroke-dasharray: 187;
		animation: internal 1.5s ease-in-out infinite;
		opacity: 0.4;
	}

	.loader .external-circle {
		stroke-dasharray: 312;
		animation: external 1.5s linear infinite;
		opacity: 0.9;
	}

	@keyframes internal {
		0% {
			stroke-dashoffset: 187;
		}
		25% {
			stroke-dashoffset: 80;
		}
		100% {
			stroke-dashoffset: 187;
			transform: rotate(360deg);
		}
	}

	@keyframes external {
		0% {
			stroke-dashoffset: 312;
			transform: rotate(70deg);
		}
		60% {
			stroke-dashoffset: -312;
		}
		100% {
			stroke-dashoffset: -312;
			transform: rotate(450deg);
		}
	}
`;

export const PagePreloader: React.FC = () => {
	return (
		<SPreloader>
			<Spinner color={theme.palette.primary.main} />
		</SPreloader>
	);
};

export const Preloader: React.FC = () => (
	<PreloaderWrapper>
		<PreloaderContent>
			<div />
			<div />
			<div />
			<div />
		</PreloaderContent>
	</PreloaderWrapper>
);
